var $543375d46d8e1e08$exports = {};
$543375d46d8e1e08$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selettore colore`,
    "colorSwatch": `campione di colore`,
    "transparent": `trasparente`,
    "twoDimensionalSlider": `Cursore 2D`
};


export {$543375d46d8e1e08$exports as default};
//# sourceMappingURL=it-IT.mjs.map
